
let _resumeFile = null;
const _listeners = new Set();

export function setResumeFile(file) {
  _resumeFile = file;
  // Notify all listeners when file changes
  _listeners.forEach(fn => fn(file));
}

export function getResumeFile() {
  return _resumeFile;
}

// ✅ NEW: subscribe to file changes
export function onResumeFileChange(callback) {
  _listeners.add(callback);
  return () => _listeners.delete(callback); // returns unsubscribe fn
}